import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './TextCycler.css';

class TextCycler extends PureComponent {
  state = {
    itemIndex: 0
  };

  timeout = null;

  componentDidMount() {
    this.scheduleNext();
  }

  scheduleNext = () => {
    const { durationMs, transitionMs, items } = this.props;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (items.length) {
      this.timeout = setTimeout(this.switchItem, durationMs + transitionMs);
    }
  };

  switchItem = () => {
    const { items } = this.props;

    if (items.length) {
      this.setState({
        itemIndex: (this.state.itemIndex + 1) % items.length
      });
      this.scheduleNext();
    }
  };

  componentWillUnmount() {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
  }

  render() {
    const { items, className } = this.props;
    const { itemIndex, transitionMs } = this.state;
    const transition = `opacity ${transitionMs}ms linear`;
    return (
      <div className={`text-cycler-container ${className || ''}`}>
        {items.map((item, idx) => {
          const opacity = idx === itemIndex ? 1 : 0;
          return (
            <span key={idx} style={{ transition, opacity }}>
              {item}
            </span>
          );
        })}
      </div>
    );
  }
}

TextCycler.propTypes = {
  durationMs: PropTypes.number,
  transitionMs: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string
};

TextCycler.defaultProps = {
  durationMs: 4000,
  transitionMs: 300
};

export default TextCycler;
